module.exports = __webpack_public_path__ + "static/20180911_193655_optimized-63023e9671a7634a85465d71e3145e18.jpg";